import { schema } from 'normalizr';

export const name = 'events';

export const eventSchema = new schema.Entity(name);

export const eventsCollectionSchema = new schema.Array(eventSchema);
